/**
 * Top-level ERP route prefixes used by the root App.tsx router.
 * Each ERP app handles its own internal sub-routes.
 */
export enum ErpRoutePrefix {
    Netsuite = '/netsuite/*',
    Intacct = '/intacct/*',
    QuickBooks = '/quickbooks/*',
    Xero = '/xero/*',
    MYOB = '/myob/*',
    Default = '/'
}